export const scrollHorizontally = (e) => {
  e.currentTarget.scrollLeft += e.deltaY;
};
